import { Typography } from "@packages/ds";
import styled, { css } from "styled-components";

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
  flex-wrap: wrap;
  margin-bottom: 32px;
  gap: 32px;
`;

export const Heading = styled(Typography.Title)`
  margin: auto;
  text-transform: capitalize;
`;

export const FlameChartLayout = styled.div<{ isVisible?: boolean }>`
  padding: 32px;
  border-radius: 8px;
  background-color: var(--section-snow-background-color, var(--snow));
  ${({ isVisible }) =>
    !isVisible &&
    //send the chart out of the viewport
    // but dont prevent it from initialising
    css`
      position: absolute;
      left: 9999px;
      bottom: 9999px;
    `};

  button.variant-secondary:not(:hover) {
    color: var(--section-night-color, var(--night)) !important;
  }

  .bf-form-control-input {
    button.variant-primary {
      border-color: ${"var(--section-periwinkle-grey-border-color,var(--periwinkle-grey))"} !important;
      color: var(--section-night-color, var(--night)) !important;
    }
  }

  button.variant-outline {
    color: var(--section-night-color, var(--night)) !important;
  }

  .bf-flamegraph-header {
    color: var(--section-night-color, var(--night)) !important;
  }

  .recharts-cartesian-axis-tick text {
    fill: var(--section-night-color, var(--night)) !important;
  }

  .profile-trigger {
    width: auto;
    padding: 4px 4px 4px 8px;
    color: var(--section-slate-color, var(--slate));
  }

  .bf-flamegraph {
    gap: 24px !important;
  }

  .bf-flamegraph-bar {
    border-top: 1px solid
      var(--section-periwinkle-grey-border-color, var(--periwinkle-grey)) !important;
    border-bottom: 1px solid
      var(--section-periwinkle-grey-border-color, var(--periwinkle-grey)) !important;
    padding: 8px 0 !important;
  }

  .bf-input {
    label {
      margin: 14px 0 !important;
    }
    input {
      background-color: var(
        --section-snow-background-color,
        var(--snow)
      ) !important;

      color: var(--section-night-color, var(--night)) !important;
      margin: 24px 0 !important;

      :hover,
      :focus,
      :active {
        outline: none !important;
        border: none !important;
        border-color: transparent !important;
        box-shadow: none !important;
      }
    }
  }
`;
